<template>
  <div id="enquiry-form" class="content-row">

    <div class="container" v-if="currentSection === 0 && !finished">
      <div class="scroll-box">

        <h1 class="title text-center text-blue2 font-alt mb-3">Enquiry Form</h1>

        <p class="font-weight-bold lead">
          Please read before applying.
        </p>
        <p>
          Thank you for considering one of our rescues as a family addition, they are wonderful dogs who all deserve to
          find a loving home.
        </p>
        <p>
          We appreciate that adopting a dog represents years of commitment. It is essential that both our dogs and their
          adoptive family are properly matched. Therefore, to help us do that, please may we ask you to <strong>answer
          all the questions fully and in as much details as possible.</strong> We know our dogs very well and knowing
          more about you will help us ensure you have a positive experience.
        </p>
        <p>
          Thank you again for your time and commitment to the process &#128522;.
        </p>
        <p>
          <i>Note: We never pressure anyone into adopting one of our dogs, it has to be right for everyone. If you
            change your mind at any point in the process, it is absolutely fine by us, we understand.</i>
        </p>
        <div class="text-center">
          <button class="btn btn-lg btn-block btn-blue2" @click="startCheck">
            OK, I understand, Continue
          </button>
        </div>

      </div>
    </div>

    <SectionBreadcrumb :current-section="currentSection" :sections="sections"
                       v-if="currentSection > 0 && !finished" class="d-none d-md-block">
    </SectionBreadcrumb>

    <SectionBreadcrumbMobile :currentSection="currentSection" :currentQuestionNumber="currentQuestionNumber"
                             v-if="currentSection > 0 && !finished" class="d-block d-md-none">
    </SectionBreadcrumbMobile>

    <div class="container">

      <div class="text-center mb-5" v-if="currentSection === 1 && !finished">
        <p class="font-weight-bold lead mb-0">
          Only proceed with the application if you are able to say yes to all of the following
        </p>
        <p class="font-weight-bold lead">
          this is to avoid you applying if you are unable to meet our basic requirements.
        </p>
      </div>

      <div v-if="currentSection > 0 && !finished">
        <form v-if="!loading" id="frmEnquiryForm" class="scroll-box" action="#" method="post">
          <!-- Loop over questions in step -->
          <div :class="this.currentSection == 1? '' :'mb-4 ml-3' " v-for="(question, questionKey) in stepQuestions"
               :key="questionKey">
            <Question ref="question" :question="question" :stepKey="stepKey" :fields="question.fields"
                      :questionNumber="question.question_number ? parseInt(question.question_number) : questionKey + 1"></Question>
          </div>
        </form>

        <div v-if="loading">
          <img src="/images/loading-dog.gif">
        </div>
        <!-- bottom buttons -->
        <div class="fixed-bottom py-3 bg-white" v-if="checkedFields">
          <div class="container">
            <div class="row row-spacing">
              <div class="col-6">
                <button class="btn btn-block btn-outline-blue2" v-on:click="stepsCheck(-1)" tabindex="9990">
                  Back
                </button>
              </div>
              <div class="col-6">
                <button class="btn btn-block btn-blue2"
                        v-if="this.currentSection < (this.sections.length -1) && allFieldsChecked"
                        v-on:click="requiredFieldsCompleted()" tabindex="9991">
                  Next
                </button>
                <button v-if="this.currentSection === (this.sections.length -1) && allFieldsChecked"
                        class="btn btn-block btn-blue2" v-on:click.prevent="submitForm" tabindex="9992">
                  Submit
                </button>

              </div>
            </div>
          </div>
        </div>

        <div class="my-3" v-if="debugMode && currentSection > 0 && !finished">
          <button type="button" class="btn btn-danger" @click="clearErrorStatus">Clear errors</button>
          <button type="button" class="btn btn-warning" @click="resetForm">Reset form</button>
          <button type="button" class="btn btn-success" @click="submitForm">Submit form</button>
        </div>

      </div>
      <div v-if="finished" class="text-center">
        <h1 class="title text-center text-blue2 font-alt mb-3">Form Submission Successful</h1>

        <p class="font-weight-bold lead">
          If we are able to proceed with your application, we will be in touch in the next couple of working days.
        </p>
        <p>
          Thank you for your interest in adopting an Underdog
        </p>
        <p class="mb-0">
          Warm wishes,<br>
          <strong>The Love Underdogs Adoption Team</strong>
        </p>
      </div>

    </div>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Axios from 'axios'
import EventBus from '~/plugins/event-bus'
import QuestionProgress from './enquiry-form-question-progress'
import SectionBreadcrumb from './enquiry-form-section-breadcrumb'
import SectionBreadcrumbMobile from './enquiry-form-section-breadcrumb-mobile'
import Question from './question.vue'
import * as types from '../../store/mutation-types'
import { isUndefined } from 'underscore'

export default {
	components: { SectionBreadcrumb, SectionBreadcrumbMobile, QuestionProgress, Question },
	useLocalStorage: false,
	name: 'enquiry-form',
	props: [],
	data: () => ({
		debugMode: false,
		agreed: null,
		checkStage: false,
		checkedFields: false,
		currentQuestionAnswer: {},
		currentQuestionNumber: 0,
		currentQuestionStep: 0,
		errors: [],
		finished: false,
		loading: false,
		introStage: true,
    // questions: [],
		questionStage: false,
		resultsStage: false,
		skipping: false,
		stepKey: 0,
		currentSection: 0
	}),

	beforeCreate () {
    // get the questions
		this.$store.dispatch('form/fetchQuestions')
    /*
    window.onbeforeunload = function () {
      return true
    }
    */
	},

	mounted: function () {
		this.clearErrorStatus()
		EventBus.$on('answerEvent', (data) => {
			this.allFieldsChecked()
		})
	},

	created: function () {
    /**
     * This catches any errors thrown to the global EventBus
     */
		EventBus.$on('QuestionError', (data) => {
			this.questionErrors(data)
		})

    /*
       * Catch a fieldChanged event
       * This is where field changes are pushed into the store
       */
		EventBus.$on('fieldChanged', (data) => {
			const oAnswer = { key: data[0], value: data[1] }
			this.$store.commit(`form/${types.ADD_ANSWER}`, oAnswer)
		})

		EventBus.$on('questionSelected', (data) => {
			this.currentQuestionNumber = data
		})
	},

	methods: {
		questionErrors: function (data) {
			const errorKeys = Object.keys(data.errors)

      // loop over all questions and check if any of the formKeys are in errorKeys
      // if they are, set the question.hasError and the message
			this.questions.forEach(question => {
				question.formKeys.forEach(key => {
					if (errorKeys.includes(key)) {
						question.hasError = true

            // add to the specified field
						question.fields.forEach(field => {
							if (errorKeys.includes(field.form_key)) {
								field.hasError = true
								field.errorMsg = data.errors[field.form_key][0]
							}
						})
					}
				})
			})

			this.$forceUpdate()
		},
		skipQuestion: function () {
			if (this.currentQuestionNumber < this.questions.length - 1) {
				const elements = this.$refs['question']
				this.skipping = true
				this.currentQuestionNumber++
				const vm = this

				elements.forEach(function (element) {
					if (vm.currentQuestionNumber === element.questionNumber) {
						vm.$refs['scroll-div'].scrollTop = (vm.$refs['question-box'][vm.currentQuestionNumber].offsetTop +
                vm.$refs['question-box'][vm.currentQuestionNumber].clientHeight / 2) -
                vm.$refs['scroll-div'].clientHeight / 2

						return
					}
				})
			}
		},

		jumpToSection: function (index) {
			this.currentSection = index
		},

		scrollToQuestion: function (section, formKey) {
			const vm = this
			const promise1 = new Promise((resolve) => {
				vm.jumpToSection(section)
				resolve('ok')
			})

			this.$nextTick(() => {
				promise1.then(message => {
					vm.scrollToElement(`#field-${formKey}`)
				})
			})
		},

		scrollToElement: function (element) {
			const options = {
				container: 'body',
				easing: 'ease',
				offset: -100,
				force: true,
				x: false,
				y: true
			}
			this.$scrollTo(element, 1000, options)
		},

		focusFirstField: function () {
			// don't focus on radio fields because if there is a defauly of 'No' it
			// causes it to highlight both yes and no
			if (document.forms.length > 0 && document.forms[0].elements[0].type !== 'radio') {
				document.forms[0].elements[0].focus()
			}
		},

		stepsCheck: function (offset) {
			if (this.currentSection === 0 || (this.currentSection + offset) > (this.sections.length - 1)) {
				return
			}
			this.currentSection += offset
			const scrollElement = (document.querySelector('.field-error') ? '.field-error' : '#enquiry-form')
			this.scrollToElement(scrollElement)
			this.$nextTick(() => this.focusFirstField())
		},

		requiredFieldsCompleted: function () {
			this.clearErrorStatus()
			const vm = this

			const fields = this.questions.filter(question => {
				return question.question_section_id === this.currentSection
			}).map(question => {
				return question.fields.filter(field => {
					return true
				}).map(function (field) {
					return field
				})
			}).flat()

			const errors = {}

			fields.forEach(field => {
        /*
        Rules
        if field.required
          check field answer
          if empty
          ERROR
        endif

        if field.required_if
          get the value of the required field answer
          check field.required_if_value against the required field answer
          if match
          check the length of this field answer.
          if empty
            ERROR
           endif
           All good
         */

        // get the answer for this field
				const currentFieldAnswer = vm.$store.getters['form/getAnswerByKey'](field.form_key)

				if (field.required) {
					if (isUndefined(currentFieldAnswer) || currentFieldAnswer.value.length === 0) {
            // no answer has been provided yet
						errors[field.form_key] = ['This field is required']
						return
					}
				}

				if (field.required_if) {
          // get the required field
					const requiredIfField = fields.find(f => f.form_key === field.required_if)
					const requiredIfAnswer = vm.$store.getters['form/getAnswerByKey'](field.required_if)

          // the parent field might not have been clicked (if a Y/N answer)
          // it might not be required
					if (requiredIfField.required && isUndefined(requiredIfAnswer)) {
            // the required_if field hasn't been answered
						errors[field.required_if] = ['This field is required']
						return
					}
					if (!isUndefined(requiredIfAnswer)) {
            // the required rules match - check we have an answer
            // at least one 'required if' answer is negated
            // i.e, required if value is not this value
						if (field.required_if_value.substr(0, 1) === '!') {
							const value = field.required_if_value.substr(1, field.required_if_value.length)
							if (value.toLowerCase() !== requiredIfAnswer.value.toLowerCase()) {
								if (isUndefined(currentFieldAnswer) || currentFieldAnswer.value.length === 0) {
									errors[field.form_key] = ['This field is required']
									return
								}
							}
						} else {
							if (field.required_if_value == requiredIfAnswer.value) {
								if (isUndefined(currentFieldAnswer) || currentFieldAnswer.value.length === 0) {
									errors[field.form_key] = ['This field is required']
									return
								}
							}
						}
					}
				} else if (field.type == 'date' && (isUndefined(currentFieldAnswer) || currentFieldAnswer.value.length <= 9)) {
					errors[field.form_key] = ['This field is required']
				}
			})

			if (Object.keys(errors).length) {
				this.questionErrors({ 'errors': errors })
				return this.stepsCheck(0)
			}

			return this.stepsCheck(1)
		},

		previousQuestion: function (e) {
			if (this.currentQuestionNumber > 0) {
				const elements = this.$refs['question']
				this.skipping = true
				this.currentQuestionNumber--

				const vm = this
				elements.forEach(function (element) {
					if (vm.currentQuestionNumber === element.questionNumber) {
						vm.$refs['scroll-div'].scrollTop = (vm.$refs['question-box'][vm.currentQuestionNumber].offsetTop +
                vm.$refs['question-box'][vm.currentQuestionNumber].clientHeight / 2) -
                vm.$refs['scroll-div'].clientHeight / 2
					}
				})
			} else if (this.currentQuestionNumber === 0) {
				this.$refs['scroll-div'].scrollTop = 0
			}
		},

		startCheck: function () {
			this.currentSection = 1
			this.introStage = false
			this.checkStage = true
			this.questionStage = false
			this.scrollToElement('#enquiry-form')
		},

		startForm: function () {
			this.currentSection = 1
			this.introStage = false
			this.checkStage = false
			this.questionStage = true
		},

		updateQuestionData: function () {
			let newValue = {}

			if (typeof this.answers[this.currentQuestionNumber] === 'object') {
				newValue = this.answers[this.currentQuestionNumber]
			} else {
				if (typeof this.questions[this.currentQuestionNumber].fields === 'object') {
          // create array with empty values for each field
					this.questions[this.currentQuestionNumber].fields.forEach(function (field) {
						newValue[field.name] = ''
					})
				}
			}

			this.currentQuestionAnswer = newValue

			if (typeof this.questions[this.currentQuestionNumber].step === 'number') {
				this.currentQuestionStep = this.questions[this.currentQuestionNumber].step
			}
		},

    /**
     * remove any question error statuses
     */
		clearErrorStatus: function () {
			if (this.questions) {
				this.questions.forEach(question => {
					question.hasError = false
					question.errorMsg = null
					question.fields.forEach(field => {
						field.hasError = false
						field.errorMsg = null
					})
				})
			}
		},

		submitForm: function () {
      // parse the answers into a simplified format
			this.loading = true
			this.clearErrorStatus()
			const postData = {}
			this.answers.forEach(answer => {
				postData[answer.key] = answer.value
			})

			Axios.post('enquiry-form', postData).then(response => {
				this.loading = false
				window.location.href = location.protocol + '//' + location.host + '/adoption-form-submission-successful'
				this.$store.commit(`form/${types.CLEAR_ANSWERS}`)
			}).catch(error => {
				this.loading = false
				EventBus.$emit('QuestionError', error.response.data)
			})
		},

		resetForm: function () {
			this.$store.commit(`form/${types.CLEAR_ANSWERS}`)
		},
		allFieldsChecked: function () {
			if (this.currentQuestionStep > 1) {
        // we only want to endforce that the first section are all entered before allowing progression
				return true
			}

      // check all sections are entered
			const questionFields = this.questions.filter(question => {
				return question.question_section_id === 1
			}).map(question => {
				return question.fields[0].form_key
			})

			const answers = []
			questionFields.forEach(field => {
				answers.push(this.$store.getters['form/getAnswerByKey'](field))
			})

			this.checkedFields = answers.filter(answer => typeof answer === 'undefined' || answer.value == false).length == 0
		}

	},

	computed: {
		...mapGetters({
			questions: 'form/questions',
			sections: 'form/sections',
			answers: 'form/answers'
		}),

		stepQuestions: function () {
      // get the questions for the current section
			const vm = this

			this.questions.forEach(function (question) {
				question.fields.sort(function (a, b) {
					return a.question_id === b.question_id ? a.order - b.order : -1
				})
			})

			return this.questions.filter(question => {
				return question.question_section_id === vm.currentSection
			}).sort(function (a, b) { return a.question_id === b.question_id ? a.order - b.order : -1 })
		}
	}
}
</script>

<style scoped>

h1.paws::before {
  color: #48c2c7;
  content: '🐾';
  margin-right: 1rem;
}

h1.paws::after {
  color: #48c2c7;
  content: '🐾';
  margin-left: 1rem;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/enquiry-form.vue